import React from 'react';
import type { Moment } from 'moment';
import { I18n } from '@aws-amplify/core';

import { UPLOAD_DATE_FIELD } from './constants';
import { FieldFormItem, UploadDatePicker } from './styles';

const DATE_FORMAT = 'L';

function isFutureDate(current: Moment): boolean {
	const result = current.valueOf() > Date.now();

	return result;
}

export function UploadDate(): JSX.Element {
	return (
		<FieldFormItem name={UPLOAD_DATE_FIELD} label={I18n.get('Upload date')} labelCol={{ span: 24 }}>
			<UploadDatePicker format={DATE_FORMAT} disabledDate={isFutureDate} />
		</FieldFormItem>
	);
}
